module.exports = "pegasus/assets/theme3/img1.png";